import React from "react";
import { useNavigate } from "react-router-dom";
// import Chip from "@mui/material/Chip";

// Custom.
import Layout from "containers/Layout/Layout";
import { EnhancedTable } from "@vocollege/components";
import {
  GET_BOOKS,
  DELETE_BOOK,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { EnhancedTableStatusCell } from "@vocollege/components";
import { EnhancedTableRoles } from "@vocollege/components/dist/EnhancedTable";

export default function Books() {
  let navigate = useNavigate();

  const editItem = (id = "create") => {
    navigate(`/content/books/${id}`);
  };

  return (
    <Layout>
      <EnhancedTable
        className="vo-global__top-bottom-space"
        title={I18n.get.book.labels.books}
        operations={{
          category: "books",
          get: GET_BOOKS,
          delete: DELETE_BOOK,
        }}
        columns={[
          { title: "ID", field: "id", width: 90 },
          { title: I18n.get.form.labels.title, field: "title" },
          {
            title: I18n.get.book.labels.parent,
            field: "parent",
            render: (rowData: any) =>
              rowData.parent
                ? `${rowData.parent.title} (id: ${rowData.parent.id})`
                : "-",
          },
          {
            title: I18n.get.misc.created_at,
            field: "created_at",
            width: 200,
          },
          {
            title: I18n.get.misc.updated_at,
            field: "updated_at",
            width: 200,
          },
          {
            title: I18n.get.misc.roles,
            field: "roles",
            width: 240,
            render: (data: any) => <EnhancedTableRoles data={data.roles} />,
          },
          {
            title: I18n.get.group.labels.groupRoles,
            field: "groupRoles",
            width: 240,
            render: (data: any) => (
              <EnhancedTableRoles data={data.groupRoles} />
            ),
          },
          {
            title: I18n.get.form.labels.status,
            field: "status",
            width: 120,
            render: (data: any) => (
              <EnhancedTableStatusCell data={data.status} />
            ),
          },
        ]}
        addItem={editItem}
        editItem={editItem}
        orderBy="UPDATED_AT"
        order="DESC"
      ></EnhancedTable>
    </Layout>
  );
}
